/**
 * Calculates the number of seconds remaining until a given timestamp.
 * @param {number} timestamp - The timestamp to calculate the remaining seconds for.
 * @returns {number} The number of seconds remaining until the specified timestamp.
 */
export const getSecondsToTimestamp = (timestamp: number) => Math.ceil((timestamp - Date.now()) / 1000);
